import { TextInput } from '@carbon/react';
import { ChangeEvent, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { EMAIL_PATTERN } from 'utils/constants';
import sharedMessages from 'Components/utils/sharedMessages';

type Props = {
    updateEmail?: (value: string) => void;
    email: string;
    form?: string;
    required?: boolean;
    disabled?: boolean;
}

const EmailInput = ({
    updateEmail,
    email,
    form,
    required,
    disabled,
}: Props) => {
    const intl = useIntl();

    const isEmailValid = useMemo(() => EMAIL_PATTERN.test(email) || email.length === 0, [email]);

    const onChange = (evt: ChangeEvent<HTMLInputElement>) => {
        updateEmail?.(evt.target.value);
    };

    return (
        <TextInput
            id="email"
            labelText={intl.formatMessage(sharedMessages.email)}
            placeholder={intl.formatMessage(sharedMessages.emailPlaceholder)}
            type="text"
            maxCount={254}
            form={form}
            disabled={disabled}
            onChange={onChange}
            value={email}
            warn={!isEmailValid}
            warnText={intl.formatMessage(sharedMessages.incorrectEmail)}
            required={required}
            title={intl.formatMessage(sharedMessages.email)}
        />
    );
};

export default EmailInput;
